/**
 * TypeScript wrapper for tauri-plugin-web-auth and tauri-plugin-opener
 * Uses ASWebAuthenticationSession on iOS and Chrome Custom Tabs on Android
 * Uses opener for desktop platforms (Windows, macOS, Linux)
 */

import { invoke } from '@tauri-apps/api/core';
import { openUrl as tauriOpenUrl } from '@tauri-apps/plugin-opener';

export interface AuthenticateOptions {
  url: string;
  callbackScheme: string;
}

export interface AuthenticateResult {
  callbackUrl: string;
}

/**
 * Opens a web authentication session for OAuth flows.
 * On iOS, uses ASWebAuthenticationSession which auto-dismisses on redirect.
 * On Android, uses Chrome Custom Tabs.
 *
 * @param options - The authentication options containing the OAuth URL and callback scheme
 * @returns The callback URL with OAuth parameters
 */
export async function authenticate(
  options: AuthenticateOptions
): Promise<AuthenticateResult> {
  return invoke('plugin:web-auth|authenticate', {
    payload: {
      url: options.url,
      callbackScheme: options.callbackScheme,
    },
  });
}

/**
 * Opens a URL in the system's default browser.
 * Used for desktop OAuth flows (Windows, macOS, Linux) where deep links
 * will capture the callback via the oauth-callback event.
 *
 * @param url - The URL to open in the default browser
 */
export async function openUrl(url: string): Promise<void> {
  // Don't pass an app parameter - let the system use the default browser
  return tauriOpenUrl(url);
}
